const SortOrder = {
  ASC: 'ascending',
  DESC: 'descending',
}

const FieldNames = {
  P1P2P3: 'p1p2p3',
  R1R2R3: 'r1r2r3',
  FAILURE_REASON: 'failureReason',
}

const EventTableHeadings = [
  {
    id: "index",
    label: "Sr no",
    sortOrder: null
  },
  {
    id: "name",
    label: "Name",
    sortOrder: SortOrder.ASC
  },
  {
    id: "siteId",
    label: "Site ID",
    sortOrder: SortOrder.ASC
  },
  {
    id: "status",
    label: "Status",
    sortOrder: SortOrder.ASC
  },
  {
    id: "subtype",
    label: "Subtype",
    sortOrder: SortOrder.ASC
  },
  {
    id: "startTime",
    label: "Start Time",
    sortOrder: SortOrder.ASC
  },
  {
    id: "endTime",
    label: "End Time",
    sortOrder: SortOrder.ASC
  },
  {
    id: "rateWatt",
    label: "Rate (W)",
    sortOrder: SortOrder.ASC
  },
  {
    id: "targetSoc",
    label: "Target SOC",
    sortOrder: SortOrder.ASC
  },
  {
    id: "avgChargePower",
    label: "Avg Chg",
    sortOrder: SortOrder.ASC
  },
  {
    id: "avgDischargePower",
    label: "Avg Dchg",
    sortOrder: SortOrder.ASC
  },
  {
    id: "avgDischarged",
    label: "AVG DCHG (GS CALC)",
    sortOrder: SortOrder.ASC
  },
  {
    id: "startSoc",
    label: "Start SOC",
    sortOrder: SortOrder.ASC
  },
  {
    id: "endSoc",
    label: "End SOC",
    sortOrder: SortOrder.ASC
  },
  {
    id: "eventRequestedAt",
    label: "Event Requested",
    sortOrder: SortOrder.ASC
  },
  {
    id: "commandSentAt",
    label: "Cmd Sent",
    sortOrder: SortOrder.ASC
  },
  {
    id: "gwCommandIssuedAt",
    label: "GW Cmd Issued",
    sortOrder: SortOrder.ASC
  },
  {
    id: "gwCommandResponseAt",
    label: "GW Cmd Response",
    sortOrder: SortOrder.ASC
  },
  {
    id: "commandAckAt",
    label: "Cmd Ack",
    sortOrder: SortOrder.ASC
  },
  {
    id: "firstReadingAt",
    label: "First Reading",
    sortOrder: SortOrder.ASC
  },
  {
    id: "lastReadingTimestamp",
    label: "Last Reading",
    sortOrder: SortOrder.ASC
  },
  {
    id: "p1p2p3",
    label: "P1 / P2 / P3",
    sortOrder: null
  },
  {
    id: "r1r2r3",
    label: "R1 / R2 / R3",
    sortOrder: null
  },
  {
    id: "eventLogs",
    label: "Event Logs",
    sortOrder: null
  },
  {
    id: "intervals",
    label: "Intervals",
    sortOrder: null
  }
]

const EventLogKeys = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh']
const TimelineDotColors = ['#7c3aed', '#2563eb', '#0891b2', '#059669', '#d97706', '#dc2626', '#6b7280']

const EventDetailRow1 = [
  { label: 'Event ID', field: 'eventId' },
  { label: 'Command Request ID', field: 'commandRequestId' },
  { label: 'Program Key', field: 'programkey' },
  { label: 'Start Epoch', field: 'startTimeEpochSeconds' },
  { label: 'End Epoch', field: 'endTimeEpochSeconds' },
]

const EventDetailRow2 = [
  { label: 'Event Requested At', field: 'eventRequestedAt' },
  { label: 'Command Sent At', field: 'commandSentAt' },
  { label: 'GW Command Sent At', field: 'gwCommandIssuedAt' },
  { label: 'GW Command Response At', field: 'gwCommandResponseAt' },
  { label: 'Command Ack At', field: 'commandAckAt' },
]

const EventDetailRow3 = [
  { label: 'First Reading At', field: 'firstReadingAt' },
  { label: 'Last Reading At', field: 'lastReadingTimestamp' },
  { label: 'P1 / P2 / P3', field: 'p1p2p3' },
  { label: 'R1 / R2 / R3', field: 'r1r2r3' },
]

const EventDetailRow4 = [
  { label: 'FAILURE REASON', field: FieldNames.FAILURE_REASON },
]

const IntervalHourlySummaryHeadings = [
  { id: 'index', label: 'Sr no', sortOrder: null },
  { id: 'hour', label: 'Hour', sortOrder: null },
  { id: 'charge', label: 'Charge (Wh)', sortOrder: null },
  { id: 'discharge', label: 'Discharge (Wh)', sortOrder: null },
  { id: 'net', label: 'Net (Wh)', sortOrder: null },
]

const IntervalDetailsHeadings = [
  { id: 'index', label: 'Sr No', sortOrder: null },
  { id: 'readingTime', label: 'Reading Time', sortOrder: null },
  { id: 'endAt', label: 'End At', sortOrder: null },
  { id: 'charge', label: 'Charge (Wh)', sortOrder: null },
  { id: 'discharge', label: 'Discharge (Wh)', sortOrder: null },
  { id: 'soc', label: 'SOC %', sortOrder: null },
  { id: 'chargePower', label: 'Charge Power (W)', sortOrder: null },
  { id: 'dischargePower', label: 'Discharge Power (W)', sortOrder: null },
]

const REQUEST_BODY_PLACEHOLDER = `{
  "siteId": 123456,
  "programkey": "Enphase Test",
  "startTime": "2026-08-01 00:00:00",
  "endTime": "2026-08-31 00:00:00"
}`

const ACTIVE_SITES_DEFAULT_BODY = `{
  "from": "20260201",
  "to": "20270101"
}`

const ACTIVE_SITES_VIEW_MODES = {
  ACTIVE_SITES: 'activeSites',
  MAX_MONTHLY: 'maxMonthlyActiveSites',
}

const ACTIVE_SITES_VIEW_LABELS = {
  [ACTIVE_SITES_VIEW_MODES.ACTIVE_SITES]: 'Active Sites',
  [ACTIVE_SITES_VIEW_MODES.MAX_MONTHLY]: 'Max Monthly',
}

const ActiveSitesTableHeadings = [
  { id: 'index', label: 'Sr No', sortable: false },
  { id: 'program', label: 'Program Name', sortable: true },
  { id: 'account', label: 'Account', sortable: true },
  { id: 'operatedBy', label: 'Operated By', sortable: false },
  { id: 'trend', label: 'Trend', sortable: true },
]

const buildActiveSitesHeadings = (dateKeys, sortCol, sortDir) => {
  return [
    { id: 'index', label: 'Sr No', sortOrder: null },
    {
      id: 'program',
      label: 'Program Name',
      sortOrder: sortCol === 'program' ? (sortDir === 1 ? SortOrder.ASC : SortOrder.DESC) : SortOrder.ASC
    },
    {
      id: 'account',
      label: 'Account',
      sortOrder: sortCol === 'account' ? (sortDir === 1 ? SortOrder.ASC : SortOrder.DESC) : SortOrder.ASC
    },
    { id: 'operatedBy', label: 'Operated By', sortOrder: null },
    ...dateKeys.map(dateKey => ({
      id: dateKey,
      label: dateKey,
      sortOrder: sortCol === dateKey ? (sortDir === 1 ? SortOrder.ASC : SortOrder.DESC) : SortOrder.ASC
    })),
    {
      id: 'trend',
      label: 'Trend',
      sortOrder: sortCol === 'trend' ? (sortDir === 1 ? SortOrder.ASC : SortOrder.DESC) : SortOrder.ASC
    },
  ]
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const EVENTS_EMPTY_TABLE_TEXT = 'No events found'
const ACTIVE_SITES_EMPTY_TABLE_TEXT = 'No Data Found'

const getErrorMessage = (error, fallback) => {
  const errorObj = error?.data?.error
  if (errorObj?.displayMessage) return errorObj.displayMessage

  const validationErrors = errorObj?.validationErrors || {}
  const messages = Object.values(validationErrors).flatMap(group =>
    typeof group === 'object' ? Object.values(group) : [group]
  )
  if (messages.length > 0) return messages.join('; ')

  return errorObj?.message || error?.message || fallback
}

export {
  EventTableHeadings,
  SortOrder,
  FieldNames,
  EventLogKeys,
  TimelineDotColors,
  EventDetailRow1,
  EventDetailRow2,
  EventDetailRow3,
  EventDetailRow4,
  IntervalHourlySummaryHeadings,
  IntervalDetailsHeadings,
  REQUEST_BODY_PLACEHOLDER,
  ACTIVE_SITES_DEFAULT_BODY,
  ACTIVE_SITES_VIEW_MODES,
  ACTIVE_SITES_VIEW_LABELS,
  ActiveSitesTableHeadings,
  buildActiveSitesHeadings,
  MONTHS,
  EVENTS_EMPTY_TABLE_TEXT,
  ACTIVE_SITES_EMPTY_TABLE_TEXT,
  getErrorMessage,
}
